export class WhiteListingResponseModel {
    public message: string;
    constructor() {}
}
